import TaxTreatmentFields from './TaxTreatmentFields';
import React, { useState, useEffect, useCallback, useRef  } from "react";
import api from '../services/apiService';
import { useParams, useNavigate } from "react-router-dom";
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { Helmet } from 'react-helmet';  // Import von React Helmet



const allowedItemTypes = ['sale', 'service', 'sparePart', 'transport'];

// Funktion zur Formatierung des Datums in "TT.MM.JJJJ"
const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

// Funktion zur Formatierung von Datum+Uhrzeit in "TT.MM.JJJJ HH:MM"
const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day     = String(date.getDate()).padStart(2, '0');
  const month   = String(date.getMonth() + 1).padStart(2, '0');
  const year    = date.getFullYear();
  const hours   = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};



const WorkshopOrderForm = ({ mode, onSave }) => {
  const { workshopOrderId } = useParams();
  const navigate = useNavigate();

  const [workshoporder, setworkshoporder] = useState({
    customerId: "",
    contactId: "",
    lwOperatorId: "",  // Ansprechpartner vor Ort hinzufügen
    
    operationLocation: "",
    notes: "",
    date: "",
    validUntil: "",
    status: "pending", // Standardstatus für Aufträge
    referenceNumber: "", 
    
    isblocked: false,  
    blockedPeriodFrom: "",
    blockedPeriodTo: "",
    plannedExecuteDate: "",
    fulfillmentDate: "", 
    itemId: null,
    workshopOrderType: "" ,
    scheduled: false,
  });



  // Zustände für Auftragspositionen und verfügbare Artikel
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const [workshoporderItems, setworkshoporderItems] = useState([]);  // State für Auftragspositionen
  const [items, setItems] = useState([]);  // State für alle verfügbaren Artikel
  const [editingRowId, setEditingRowId] = useState(null); // Verfolgt die aktuell bearbeitete Zeile
  const [, setUnits] = useState([]); // State für Einheiten
  const [, setSelectedUnitId] = useState(null); // Zustand für die zuletzt verwendete Einheit
  
  
  const [originalworkshoporderItems, setOriginalworkshoporderItems] = useState([]);
  
  const [allItems, setAllItems] = useState([]);
  const [, setSelectedAllItem] = useState(null);
  const [uvvs, setUvvs] = useState([]);
  const [uvvLoading, setUvvLoading] = useState(false);

  // UVV Modal
  const [uvvModalOpen, setUvvModalOpen] = useState(false);
  const [uvvTypeChoice, setUvvTypeChoice] = useState('main'); // 'main' | 'retest'

  // --- OperationLocation Suggest ---
  const [opLocInput, setOpLocInput] = useState('');
  const [opLocSuggest, setOpLocSuggest] = useState([]);
  const [opLocOpen, setOpLocOpen] = useState(false);
  const [opLocLoading, setOpLocLoading] = useState(false);
  const [opLocIndex, setOpLocIndex] = useState(-1);
  const opLocWrapRef = useRef(null);

  // ---- Helper: OperationLocation merken (Remember) ----
  const rememberOpLoc = useCallback(async (label) => {
    try {
      const trimmed = String(label || '').trim();
      if (!trimmed) return;
      await api.post('/operation-locations/remember', { label: trimmed });
    } catch (e) {
      // Soft fail – kein Alert, nur Log
      console.warn('[rememberOpLoc] failed:', e?.response?.data || e?.message || e);
    }
  }, []);

  // Button klick: Modal öffnen
  const onClickCreateUvv = () => {
    if (!workshoporder?.id) return;
    setUvvTypeChoice('main');
    setUvvModalOpen(true);
  };

  // Modal bestätigen → UVV anlegen
  const confirmCreateUvv = async () => {
    try {
      const payload = {
        uvvType: uvvTypeChoice,
        inspectionDate: new Date().toISOString().slice(0,10),
        operationLocation: workshoporder.operationLocation || null,
        inspectionToLW: false,
      };
      const { data } = await api.post(`/workshoporders/${workshoporder.id}/uvvinspections`, payload);
      setUvvModalOpen(false);
      await fetchUvvs(workshoporder.id);
      navigate(`/uvv/inspections/${data.id}/edit`);
    } catch (e) {
      console.error('UVV anlegen fehlgeschlagen', e);
      alert(e?.response?.data?.error || 'UVV konnte nicht angelegt werden.');
    }
  };

  const fetchUvvs = useCallback(async (id) => {
    if (!id) return;
    try {
      setUvvLoading(true);
      const { data } = await api.get(`/workshoporders/${id}/uvvinspections`);
      setUvvs(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('UVVs laden fehlgeschlagen', e);
      setUvvs([]);
    } finally {
      setUvvLoading(false);
    }
  }, []);



  const normalizeDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    // Extrahiere "YYYY-MM-DD" aus dem ISO-String
    return date.toISOString().split("T")[0];
  };
  

  const workshopOrderTypeOptions = [
    { value: 'inspection', label: 'Inspektion' },
    { value: 'repair', label: 'Reparatur' },
    { value: 'refuel', label: 'Tanken' },
    { value: 'cleaning', label: 'Reinigung' },
    { value: 'precheck', label: 'Vorkontrolle' },
    { value: 'postcheck', label: 'Nachkontrolle' },
    { value: 'service',    label: 'Service' } // <— HINZUGEFÜGT
  ];


  const handleFulfillmentDateChange = (e) => {
  const value = e.target.value; // entweder "YYYY-MM-DD" oder ""
  setworkshoporder(prev => ({
    ...prev,
    fulfillmentDate: value,
    // wenn das Feld leer ist, ändern wir auch den Status zurück:
    status: value ? prev.status : "pending"
  }));
};


  // Funktion zur Aktualisierung der Einheit im Backend
  const updateworkshoporderItemUnit = async (workshopOrderId, workshoporderItemId, newUnitId, newQuantity) => {
    try {
      const payload = {
        id: workshoporderItemId,
        unitId: newUnitId,
        quantity: newQuantity,  // Hier fügst du die Menge hinzu
      };

      const response = await api.put(
        `/workshoporders/${workshopOrderId}/workshoporderitems/${workshoporderItemId}`, 
        payload
      );
      console.log('Einheit und Menge erfolgreich aktualisiert:', response.data);
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Einheit:', error);
    }
  };



  // Auftragspositionen entfernen
  const removeworkshoporderItem = async (workshoporderItemId) => {
    console.log("Remove-Handler aufgerufen mit ID:", workshoporderItemId);
    try {
      console.log(`Entferne Auftragsposition mit ID: ${workshoporderItemId} für Auftrag ID: ${workshoporder.id}`);

      // API-Aufruf, um die Auftragsposition zu entfernen
      const response = await api.delete(`/workshoporders/${workshoporder.id}/workshoporderitems/${workshoporderItemId}`);
      console.log('API-Antwort beim Entfernen:', response.data, 'Status:', response.status);

      // Überprüfen, ob die Antwort erfolgreich war
      if (response.status === 200 || response.status === 204) {
        // Entferne das workshoporderItem aus dem lokalen State
        setworkshoporderItems((prevItems) => {
          const updatedItems = prevItems.filter((item) => item.id !== workshoporderItemId);
          console.log("Aktualisierte Auftragspositionen nach dem Entfernen:", updatedItems); // Log hinzufügen
          return updatedItems;
        });

        console.log(`Auftragsposition mit ID ${workshoporderItemId} erfolgreich entfernt.`);
      } else {
        console.error(`Fehler beim Entfernen der Auftragsposition: Unerwarteter Status ${response.status}`);
      }
    } catch (error) {
      // Detaillierte Fehlerbehandlung und Logausgabe
      console.error('Fehler beim Entfernen der Auftragsposition:', error.message || error);

      // Benutzer über den Fehler informieren
      alert('Fehler: Die Auftragsposition konnte nicht entfernt werden. Bitte versuchen Sie es später erneut.');
    }
  };

  // Funktion zum Abrufen der Auftragspositionen
  // Funktion zum Abrufen der Auftragspositionen
const fetchworkshoporderItems = async () => {
  try {
    // Nimm die ID aus dem State (falls bereits geladen), sonst aus der URL
    const id = workshoporder?.id || workshopOrderId;

    if (!id) {
      console.warn('⚠️ fetchworkshoporderItems: keine gültige ID vorhanden – Abbruch.');
      return;
    }

    const url = `/workshoporders/${id}/workshoporderitems`;
    console.log('⬆️ Lade Auftragspositionen von:', url);

    const response = await api.get(url);
    if (Array.isArray(response.data)) {
      const itemsWithFlag = response.data.map(item => ({
        ...item,
        manualPriceActive: false
      }));
      setworkshoporderItems(itemsWithFlag);
    } else {
      console.warn('⚠️ Unerwartetes Antwortformat für workshoporderitems:', response.data);
      setworkshoporderItems([]);
    }
  } catch (error) {
    // Hier siehst du künftig exakt, was angefragt wurde und warum es 404 ist
    console.error('❌ Fehler beim Abrufen der Auftragspositionen:', {
      urlTried: `/workshoporders/${workshoporder?.id || workshopOrderId}/workshoporderitems`,
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message
    });
  }
};


  // 1. Auftragspositionen abrufen, wenn workshoporder.id sich ändert
  useEffect(() => {
  const id = workshoporder?.id || workshopOrderId;
  if (!id) return;       // ohne ID nichts laden
  fetchworkshoporderItems();
  fetchUnits();
}, [workshoporder?.id, workshopOrderId]);


  

  // 3. Artikel laden (nur beim ersten Laden der Seite)
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await api.get('/items');
        const filteredItems = response.data.filter(item => allowedItemTypes.includes(item.itemType));
        setItems(filteredItems);
      } catch (error) {
        console.error('Fehler beim Laden der Artikel:', error);
      }
    };
    fetchItems();
  }, []);


  useEffect(() => {
    const fetchAllItems = async () => {
      try {
        const response = await api.get('/items');
        setAllItems(response.data);
      } catch (error) {
        console.error('Fehler beim Laden aller Artikel:', error);
      }
    };
    fetchAllItems();
  }, []);
  
    useEffect(() => {
    const id = workshoporder?.id || workshopOrderId;
    if (id) fetchUvvs(id);
  }, [workshoporder?.id, workshopOrderId, fetchUvvs]);

  useEffect(() => {
    setOpLocInput(workshoporder?.operationLocation || '');
  }, [workshoporder?.operationLocation]);

  const fetchOpLocSuggest = useCallback(
    debounce(async (q) => {
      try {
        setOpLocLoading(true);
        const { data } = await api.get('/operation-locations/suggest', {
          params: { q, limit: 12 }
        });
        setOpLocSuggest(Array.isArray(data) ? data : []);
        setOpLocOpen(true);
      } catch (e) {
        console.error('operationLocation suggest failed', e);
        setOpLocSuggest([]);
      } finally {
        setOpLocLoading(false);
      }
    }, 250),
    []
  );

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      fetchOpLocSuggest.cancel?.();
    };
  }, [fetchOpLocSuggest]);

  const onOpLocChange = (e) => {
    const v = e.target.value;
    setOpLocInput(v);
    setworkshoporder(prev => ({ ...prev, operationLocation: v }));
    fetchOpLocSuggest(v.trim());
  };

  const onOpLocFocus = () => {
    // Ohne Eingabe: Top-Treffer anzeigen
    fetchOpLocSuggest('');
  };

  const onOpLocBlur = async () => {
    // Freitext übernehmen und merken
    const v = (opLocInput || '').trim();
    if (!v) return;
    await rememberOpLoc(v);
  };

  const selectOpLoc = async (label) => {
    setworkshoporder(prev => ({ ...prev, operationLocation: label }));
    setOpLocInput(label);
    setOpLocOpen(false);
    setOpLocIndex(-1);
    await rememberOpLoc(label); // Nutzung hochzählen
  };

  // Click outside zum Schließen
  useEffect(() => {
    const onDocClick = (e) => {
      if (!opLocWrapRef.current) return;
      if (!opLocWrapRef.current.contains(e.target)) {
        setOpLocOpen(false);
        setOpLocIndex(-1);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const onOpLocKeyDown = async (e) => {
    if (opLocOpen && opLocSuggest.length) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setOpLocIndex((i) => (i + 1) % opLocSuggest.length);
        return;
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setOpLocIndex((i) => (i - 1 + opLocSuggest.length) % opLocSuggest.length);
        return;
      } else if (e.key === 'Enter') {
        e.preventDefault();
        const pick = opLocSuggest[opLocIndex] || opLocSuggest[0];
        if (pick) {
          await selectOpLoc(pick.label);
          return;
        }
      } else if (e.key === 'Escape') {
        setOpLocOpen(false);
        setOpLocIndex(-1);
        return;
      }
    }
    // Enter bei leerem Suggest: Freitext übernehmen + remember
    if (e.key === 'Enter') {
      const v = (opLocInput || '').trim();
      if (v) {
        setworkshoporder(prev => ({ ...prev, operationLocation: v }));
        await rememberOpLoc(v);
        setOpLocOpen(false);
        setOpLocIndex(-1);
      }
    }
  };



  // Auftragsposition hinzufügen
  const addworkshoporderItem = async () => {
    try {
      if (!selectedItemId || selectedQuantity <= 0) {
        alert('Bitte wählen Sie einen Artikel aus und geben Sie eine gültige Menge an.');
        console.warn("Ungültige Eingabedaten: ", { selectedItemId, selectedQuantity });
        return;
      }

      const item = items.find((item) => item.id === selectedItemId);
      if (!item) {
        alert('Ausgewählter Artikel existiert nicht.');
        return;
      }

      if (!allowedItemTypes.includes(item.itemType)) {
        alert(`Artikel vom Typ "${item.itemType}" sind nicht erlaubt.`);
        return;
      }


      // Bestimme die finale Einheit basierend auf itemType
      let finalUnitId = null;

      switch (item.itemType) {
        case 'insurance':
          // Versicherungsartikel => standardmäßig 33 (Prozent)
          finalUnitId = 33;
          break;

        case 'rental':
          // Mietartikel => Fallback aus typePricings oder Transport
          finalUnitId =
            item.machineType?.typePricings?.[0]?.unit?.id ||
            item.transportPricings?.[0]?.unit?.id ||
            29; // oder 27 - je nachdem was du als Default willst (Stunde / Tag)
          break;

        case 'transport':
          // Transportartikel => Falls du TransportPricing hast
          finalUnitId = item.transportPricings?.[0]?.unit?.id || 34; 
          // 34 wäre z.B. "pauschal" – passe das an dein System an
          break;

        case 'sparePart':
        case 'service':
        case 'sale':
          // Ersatzteil / Service / Verkauf => aus salesPricings
          finalUnitId = item.salesPricings?.[0]?.unitId || null;
          break;
          
        default:
          // Falls es noch andere Typen gibt
          console.log(`Kein Fallback definiert für itemType='${item.itemType}'.`);
          finalUnitId = null;
          break;
      }

      // Falls finalUnitId immer noch null ist, wirf einen Fehler oder setze einen Default
      if (!finalUnitId) {
        console.warn(`Keine passende Einheit für itemType='${item.itemType}' gefunden; bitte manuell zuweisen.`);
        // finalUnitId = 29; // z.B. Tag als letzter Ausweg
      }

      const payload = {
        workshopOrderId: workshoporder.id, // ID des aktuellen Auftrags
        itemId: selectedItemId, // ID des ausgewählten Artikels
        quantity: selectedQuantity, // Vom Benutzer eingegebene Menge
        unitId: finalUnitId,  // Einheit setzen
        
       
      };

      console.log("Daten für den POST-Request:", payload);

      // API-Aufruf zur Erstellung einer neuen Auftragsposition
      const response = await api.post(`/workshoporders/${workshopOrderId}/workshoporderitems`, payload);
      console.log("API-Antwort nach Hinzufügen der Auftragsposition:", response.data);

      // Fetching der neuen Auftragspositionen nach dem Hinzufügen
      await fetchworkshoporderItems(); // Ruft die Liste erneut ab, um sicherzustellen, dass alles aktualisiert wird

      // Reset des ausgewählten Artikels und der Menge
      setSelectedItemId(null);
      setSelectedQuantity(1);
    } catch (error) {
      console.error('Fehler beim Hinzufügen der Auftragsposition:', error);
    }
  };



  // Einheiten abrufen und im Zustand speichern
  const fetchUnits = async () => {
    try {
      const response = await api.get('/units'); // Beispiel-Endpoint zum Abrufen der Einheiten
      console.log("Geladene Einheiten:", response.data);
      setUnits(response.data); // Setze den Zustand für die Einheiten
    } catch (error) {
      console.error('Fehler beim Abrufen der Einheiten:', error);
    }
  };

 



  const saveChanges = async () => {
    try {
      console.log('Speichere Daten der Auftragspositionen:', workshoporderItems);

      const updatePromises = workshoporderItems.map(async (item) => {
        const payload = {
          id: item.id,
          itemId: item.itemId,
          quantity: item.quantity,
          unitId: item.unitId,
          
          pricePerUnit: item.pricePerUnit,
          manualPriceActive: item.manualPriceActive,  // Das Flag mitübermitteln
          description: item.description,
        };

        try {
          const response = await api.put(
            `/workshoporders/${workshoporder.id}/workshoporderitems/${item.id}`,
            payload
          );
          if (response.status === 200 || response.status === 204) {
            console.log(`Position ${item.id} erfolgreich gespeichert.`);
          }
        } catch (err) {
          console.error(`Fehler beim Speichern der Position ${item.id}:`, err);
          throw new Error(`Fehler beim Speichern der Position ${item.id}`);
        }
      });

      await Promise.all(updatePromises);

      console.log('Alle Positionen erfolgreich gespeichert.');

      // Abrufen der aktuellen Positionen
      const updatedResponse = await api.get(`/workshoporders/${workshoporder.id}/workshoporderitems`);
      console.log('Backend-Daten vor Verarbeitung:', updatedResponse.data);

      if (Array.isArray(updatedResponse.data)) {
        setworkshoporderItems(updatedResponse.data);
        console.log('OrderItems nach Backend-Synchronisation:', updatedResponse.data);
      }

      alert('Alle Änderungen wurden erfolgreich gespeichert!');
      setEditingRowId(null);
    } catch (error) {
      console.error('Fehler beim Speichern der Änderungen:', error);
      alert('Fehler: Änderungen konnten nicht gespeichert werden.');
    }
  };

  
  // Funktion zur Bestimmung der Standard-Einheit
  const getDefaultUnitId = (itemType) => {
    switch (itemType) {
      case 'sale':
      case 'service':
      case 'sparePart':
        return 29; // Standard: Stück
      case 'transport':
        return 34; // Standard: Transportpauschale
      default:
        return null;
    }
  };
  
  



  useEffect(() => {
    if (editingRowId) {
      console.log("Bearbeitungsmodus aktiviert. Speichere aktuelle workshoporderItems:", workshoporderItems);
      setOriginalworkshoporderItems([...workshoporderItems]); // Kopie der aktuellen workshoporderItems speichern
    }
  }, [editingRowId, workshoporderItems]);

  const handleCancelEdit = () => {
    console.log("Abbrechen gedrückt. Original workshoporderItems:", originalworkshoporderItems);

    if (!originalworkshoporderItems || originalworkshoporderItems.length === 0) {
      console.warn("Keine Originaldaten zum Zurücksetzen gefunden.");
      return;
    }

    // Setze workshoporderItems auf die ursprünglichen Werte zurück
    setworkshoporderItems([...originalworkshoporderItems]);
    console.log("workshoporderItems nach Abbrechen zurückgesetzt auf:", originalworkshoporderItems);

    // Beende den Bearbeitungsmodus
    setEditingRowId(null);
  };


  const fetchFilteredItems = debounce(async (searchTerm) => {
    try {
      const response = await api.get(`/items?search=${searchTerm}`);
      setItems(response.data); // Aktualisiere die Artikel-Liste mit den gefilterten Artikeln
    } catch (error) {
      console.error('Fehler beim Filtern der Artikel:', error);
    }
  }, 300); // 300ms Verzögerung



  const formatItemOptionLabel = (item) => {
    const description = String(item?.description || '').trim();
    return `${item.name}${description ? ` - ${description}` : ''} (${item.itemType})`;
  };

  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customerContacts, setCustomerContacts] = useState([]);
  const [lwOperatorContacts, setLWOperatorContacts] = useState([]); // State für Ansprechpartner vor Ort (LW-Bediener)
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [, setSelectedLWOperator] = useState(null); // State für den ausgewählten Ansprechpartner vor Ort
  const [isLoading, setIsLoading] = useState(true);
  const [contactsLoadedForCustomer, setContactsLoadedForCustomer] = useState(null);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Kunden laden (nur einmal beim initialen Rendern)
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        console.log("Kunden werden geladen...");
        const customersResponse = await api.get("/customers");
        const loadedCustomers = customersResponse.data;
        setCustomers(loadedCustomers);
        setFilteredCustomers(loadedCustomers); // Zu Beginn alle Kunden anzeigen
        console.log("Kunden geladen:", loadedCustomers);
      } catch (error) {
        console.error("Fehler beim Laden der Kunden:", error);
      }
    };

    fetchCustomers();
  }, []);

  // Funktion, um die Kontakte eines bestimmten Kunden zu laden
  const loadContactsForCustomer = useCallback(async (customerId, contactId = null) => {
    try {
      if (!customerId || customerId === contactsLoadedForCustomer) return;

      console.log(`Lade Kontakte für Kunde mit ID: ${customerId}`);
      const response = await api.get(
        `/contacts/customer/${customerId}?contactFunction=Besteller`
      );
      setCustomerContacts(response.data);
      setContactsLoadedForCustomer(customerId);
      console.log("Kontakte geladen:", response.data);

      if (contactId) {
        const selectedContact = response.data.find(
          (contact) => contact.id.toString() === contactId.toString()
        );
        if (selectedContact) {
          setSelectedContact(selectedContact);
          console.log("Ausgewählter Besteller gesetzt:", selectedContact);
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden der Besteller:", error);
    }
  }, [contactsLoadedForCustomer]);

  // Funktion, um die LW-Bediener-Kontakte eines bestimmten Kunden zu laden
  const loadLWOperatorContacts = useCallback(async (customerId, lwOperatorId = null) => {
    try {
      if (!customerId) return;

      console.log(`Lade LW-Bediener für Kunde mit ID: ${customerId}`);
      const response = await api.get(
        `/contacts/customer/${customerId}?contactFunction=LW-Bediener`
      );
      setLWOperatorContacts(response.data);
      console.log("LW-Bediener geladen:", response.data);

      if (lwOperatorId) {
        const selectedLWOperator = response.data.find(
          (contact) => contact.id.toString() === lwOperatorId.toString()
        );
        if (selectedLWOperator) {
          setSelectedLWOperator(selectedLWOperator);
          console.log("Ausgewählter Ansprechpartner vor Ort gesetzt:", selectedLWOperator);
        }
      }
    } catch (error) {
      console.error("Fehler beim Laden der LW-Bediener:", error);
    }
  }, [setLWOperatorContacts]);

  // Auftrag und zugehörige Daten laden, falls im Bearbeitungsmodus
  useEffect(() => {
    if (mode === "edit" && workshopOrderId && customers.length > 0 && !initialDataLoaded) {
      const fetchworkshoporderData = async () => {
        try {
          console.log("Auftrag wird geladen...");
          const workshoporderResponse = await api.get(`/workshoporders/${workshopOrderId}`);
          const fetchedworkshoporder = workshoporderResponse.data;

          console.log("Geladener Auftrag:", fetchedworkshoporder);

          setworkshoporder({
            ...fetchedworkshoporder,
           
          });

          console.log("Auftrag gesetzt:", fetchedworkshoporder);

          if (fetchedworkshoporder.customerId) {
            const selectedCustomer = customers.find(
              (customer) => customer.id.toString() === fetchedworkshoporder.customerId.toString()
            );
            if (selectedCustomer) {
              setSelectedCustomer(selectedCustomer);
              console.log("Ausgewählter Kunde gesetzt:", selectedCustomer);
              // Kontakte und LW-Bediener nur einmal laden
              await loadContactsForCustomer(fetchedworkshoporder.customerId, fetchedworkshoporder.contactId);
              await loadLWOperatorContacts(fetchedworkshoporder.customerId, fetchedworkshoporder.lwOperatorId);
            }
          }
        } catch (error) {
          console.error("Fehler beim Laden des Auftrags:", error);
        } finally {
          setInitialDataLoaded(true);
          setIsLoading(false);
        }
      };

      fetchworkshoporderData();
    } else {
      setIsLoading(false);
    }
  }, [mode, workshopOrderId, customers, initialDataLoaded, loadContactsForCustomer, loadLWOperatorContacts]);



  // Funktion zum Filtern der Kunden (debounced, um unnötige Anfragen zu vermeiden)
  const filterCustomers = debounce((inputValue) => {
    if (inputValue.trim() === "") {
      setFilteredCustomers(customers);
    } else {
      const filtered = customers.filter((customer) =>
        `${customer.company} ${customer.customerNumber} ${customer.firstName} ${customer.lastName} ${customer.street} ${customer.postalCode} ${customer.city}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      );
      setFilteredCustomers(filtered);
    }
  }, 300);

  // Handle search field changes
  const handleCustomerSearchChange = (inputValue) => {
    filterCustomers(inputValue);
  };

  // Auftrag auswählen und alle zugehörigen Daten laden
  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setworkshoporder((prev) => ({
        ...prev,
        customerId: "",
        contactId: "", // Kontakt ebenfalls zurücksetzen
        lwOperatorId: "", // Ansprechpartner vor Ort zurücksetzen
      }));
      setSelectedCustomer(null);
      setCustomerContacts([]);
      setSelectedContact(null);
      setLWOperatorContacts([]);
      setSelectedLWOperator(null);
      return;
    }

    const selectedCustomerId = selectedOption.value;

    // Den neuen Kunden setzen und Besteller zurücksetzen
    setworkshoporder((prev) => ({
      ...prev,
      customerId: selectedCustomerId,
      contactId: "", // Zurücksetzen des Bestellers, da der Kunde geändert wurde
      lwOperatorId: "", // Zurücksetzen des LW-Bedieners
    }));

    // Den ausgewählten Kunden im Zustand speichern und anzeigen
    const selected = customers.find(
      (customer) => customer.id.toString() === selectedCustomerId.toString()
    );
    if (selected) {
      setSelectedCustomer(selected);
      console.log("Ausgewählter Kunde geändert:", selected);
      // Kontakte für den neuen Kunden laden
      loadContactsForCustomer(selectedCustomerId);
      loadLWOperatorContacts(selectedCustomerId);
    } else {
      setSelectedCustomer(null);
      console.log("Kunde konnte nicht gefunden werden");
    }
  };

  // Funktion zum Aktualisieren von Feldern (z.B. date, deliveryTime, etc.)
  const handleChange = (e) => {
    const { name, value } = e.target;

    setworkshoporder(prev => {
      const updatedworkshoporder = {
        ...prev,
        [name]: value, // Aktualisiere das geänderte Feld
      };

      

      return updatedworkshoporder;
    });
  };

  // Besteller ändern
  const handleContactChange = (e) => {
    const selectedContactId = e.target.value;
    setworkshoporder((prev) => ({
      ...prev,
      contactId: selectedContactId,
    }));

    const selected = customerContacts.find(
      (contact) => contact.id.toString() === selectedContactId.toString()
    );
    if (selected) {
      setSelectedContact(selected);
      console.log("Ausgewählter Besteller geändert:", selected);
    } else {
      setSelectedContact(null);
      console.log("Besteller konnte nicht gefunden werden");
    }
  };

  // Ansprechpartner vor Ort ändern
  const handleLWOperatorChange = (e) => {
    const selectedLWOperatorId = e.target.value;
    setworkshoporder((prev) => ({
      ...prev,
      lwOperatorId: selectedLWOperatorId,
    }));

    const selected = lwOperatorContacts.find(
      (contact) => contact.id.toString() === selectedLWOperatorId.toString()
    );
    if (selected) {
      setSelectedLWOperator(selected);
      console.log("Ausgewählter Ansprechpartner vor Ort geändert:", selected);
    } else {
      setSelectedLWOperator(null);
      console.log("Ansprechpartner vor Ort konnte nicht gefunden werden");
    }
  };

  // Funktion, um Gesamtsummen zu berechnen und im Backend zu speichern
  const saveworkshoporderTotals = async () => {
    const totalNet = workshoporderItems.reduce((sum, item) => sum + (item.total || 0), 0); // Summe der Netto-Werte
    const vatRate = workshoporder.vatRate ?? 19; // MwSt.-Satz aus dem Auftrag oder Standardwert
    const vatAmount = totalNet * (vatRate / 100); // Berechnung der MwSt.
    const totalGross = totalNet + vatAmount; // Brutto = Netto + MwSt.

    try {
      await api.put(`/workshoporders/${workshoporder.id}`, {
        taxTreatment: workshoporder.taxTreatment,
        taxNote: workshoporder.taxNote,
        totalNet,
        vatAmount,
        totalGross,
      });
      console.log('Gesamtsummen erfolgreich gespeichert.');
    } catch (error) {
      console.error('Fehler beim Speichern der Gesamtsummen:', error);
      alert(error.response?.data?.error || 'Fehler beim Speichern der Gesamtsummen.');
      return false;
    }
  };


  // Auftrag speichern
const handleSave = async () => {
    // 1️⃣ Kunde muss ausgewählt sein
    if (!workshoporder.customerId) {
      alert("Bitte wählen Sie einen Kunden aus.");
      return;
    }

    console.log("Auftrag, der gespeichert wird (State):", workshoporder);

    try {
      // 2️⃣ Basis-Felder berechnen: date, validUntil, Status
      const workshoporderDate = workshoporder.date || new Date().toISOString();
      const validUntilDate = workshoporder.validUntil ||
        new Date(new Date(workshoporderDate).setDate(new Date(workshoporderDate).getDate() + 14)).toISOString();

      // Status‐Logik: Draft → pending, "inprogress" → "inProgress"
      let finalStatus = workshoporder.status;
      if (mode === "edit" && workshoporder.status?.toLowerCase() === "draft") {
        finalStatus = "pending";
      } else if (finalStatus?.toLowerCase() === "inprogress") {
        finalStatus = "inProgress";
      }

      // 3️⃣ fulfillmentDate aus dem State ("YYYY-MM-DD") in ISO‐String umwandeln (oder null)
      let fulfillmentDateIso = null;
      if (workshoporder.fulfillmentDate) {
        // Beispiel: workshoporder.fulfillmentDate === "2025-06-16"
        const parsed = new Date(workshoporder.fulfillmentDate);
        if (!isNaN(parsed.getTime())) {
          fulfillmentDateIso = parsed.toISOString(); 
          // ergibt z. B. "2025-06-16T00:00:00.000Z"
        }
        // andernfalls bleibt fulfillmentDateIso = null
      }

      // 4️⃣ Payload zusammenstellen – hier muss fulfillmentDate als ISO‐String (oder null) übergeben werden:
      const payload = {
        taxTreatment: workshoporder.taxTreatment,
        taxNote: workshoporder.taxNote,
        customerId:        workshoporder.customerId,
        contactId:         workshoporder.contactId       || null,
        lwOperatorId:      workshoporder.lwOperatorId    || null,
        date:              workshoporderDate,
        validUntil:        validUntilDate,
        status:            finalStatus,
        notes:             workshoporder.notes           || null,
        operationLocation: workshoporder.operationLocation || null,
        referenceNumber:   workshoporder.referenceNumber   || null,
        blockedPeriodFrom: workshoporder.blockedPeriodFrom
                            ? new Date(workshoporder.blockedPeriodFrom).toISOString()
                            : null,
        blockedPeriodTo:   workshoporder.blockedPeriodTo
                            ? new Date(workshoporder.blockedPeriodTo).toISOString()
                            : null,
        isblocked:         workshoporder.isblocked,
        itemId:            workshoporder.itemId          || null,
        workshopOrderType: workshoporder.workshopOrderType,
        scheduled:         workshoporder.scheduled,
        timestarttofinish: workshoporder.timestarttofinish || null,

        // ✳️ Wichtig: fulfillmentDate hier _ explizit _ als ISO‐String (oder null) mitschicken
        fulfillmentDate:   fulfillmentDateIso,

        // Falls du plannedExecuteDate NICHT mehr brauchst, lässt du es weg. 
        // Andernfalls so:
         plannedExecuteDate: workshoporder.plannedExecuteDate
          ? new Date(workshoporder.plannedExecuteDate).toISOString()
          : null,
      };

      // 5️⃣ Je nachdem, ob wir im Bearbeitungsmodus sind:
      if (mode === "edit") {
        await api.put(`/workshoporders/${workshopOrderId}`, payload);
        alert("Auftrag erfolgreich aktualisiert!");
      } else {
        const response = await api.post("/workshoporders", payload);
        alert(`Auftrag erfolgreich erstellt! Auftragsnummer: ${response.data.workshopOrderNumber}`);
      }

      // 6️⃣ Gesamtsummen neu berechnen
      await saveworkshoporderTotals();
      if (onSave) onSave();
      navigate("/workshoporders");
    } catch (error) {
      console.error("Fehler beim Speichern des Auftrags:", error);
      alert(error.response?.data?.error || "Der Beleg konnte nicht gespeichert werden.");
    }
  };

  // Kundenoptionen für React Select
  const customerOptions = filteredCustomers.map((customer) => ({
    value: customer.id,
    label: `${customer.company} (${customer.customerNumber})`,
  }));

  if (isLoading) {
    return <div>Daten werden geladen...</div>;
  }


 // 🟢 Sortierung der Auftragspositionen VOR dem Rendern
  const sortedItems = [...workshoporderItems].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));


  return (
    <div key={workshopOrderId} className="workshoporder-form-container">
      <Helmet>
        <title>WA-bearbeiten</title>
        <meta name="description" content="WA-bearbeiten" />
      </Helmet>
      <h1>{mode === "edit" ? "Werkstattauftrag bearbeiten" : "Neuen Auftrag erstellen"}</h1>

      {mode === "edit" && (
      <div style={{ marginBottom: '1rem', fontSize: '0.9rem', color: '#555' }}>
        <div>
          <strong>Erstellt von:</strong>{' '}
          {workshoporder.creator
            ? `${workshoporder.creator.firstName} ${workshoporder.creator.lastName}`
            : 'Unbekannt'}{' '}
          am {formatDateTime(workshoporder.createdAt)}
        </div>
        <div>
          <strong>Zuletzt geändert von:</strong>{' '}
          {workshoporder.updator
            ? `${workshoporder.updator.firstName} ${workshoporder.updator.lastName}`
            : 'Unbekannt'}{' '}
          am {formatDateTime(workshoporder.updatedAt)}
        </div>
      </div>
    )}

      <div className="form-row">
        {/* Linke Spalte - Adressblock */}
        <div className="col">
          <label htmlFor="customerId" className="full-width">
            Kunde auswählen:
            <Select
              id="customerId"
              name="customerId"
              options={customerOptions}
              onInputChange={handleCustomerSearchChange}
              onChange={handleCustomerChange}
              value={customerOptions.find(option => option.value === workshoporder.customerId) || null}
              className="select-box-cst"
              isClearable
              placeholder="Kunde suchen..."
            />
          </label>

          {/* Adressblock - Anzeige der Kundendaten */}
          {selectedCustomer && (
            <div className="customer-details">
              <p><strong>Firma:</strong> {selectedCustomer.company}</p>
              <p><strong>Zusatz:</strong> {selectedCustomer.companyAddon}</p>
              <p><strong>Anrede:</strong> {selectedCustomer.salutation} {selectedCustomer.firstName} {selectedCustomer.lastName}</p>
              <p><strong>Adresse:</strong> {selectedCustomer.street}, {selectedCustomer.postalCode} {selectedCustomer.city}</p>
              <TaxTreatmentFields document={workshoporder} onChange={setworkshoporder} customer={selectedCustomer} />
              {/* Neue Felder */}
              <div style={{ marginTop: "80px" }}>
    <p>
      <strong>Arbeitszeit total:</strong>{" "}
      {workshoporder.timestarttofinish
        ? workshoporder.timestarttofinish + " Stunden"
        : "-"}
    </p>
    <p>
      <strong>Auftrag beendet am:</strong>{" "}
      {workshoporder.fulfillmentDate
        ? formatDate(workshoporder.fulfillmentDate)
        : "-"}
    </p>
    </div>
 {/* ====================== UVV Bericht ====================== */}
              <div
                style={{
                  marginTop: 16,
                  padding: '12px 0',
                  borderTop: '1px solid #e5e5e5',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {uvvLoading ? (
                  <p style={{ margin: 0 }}>UVV-Bericht wird geladen …</p>
                ) : uvvs.length === 0 ? (
                  <button
                    type="button"
                    onClick={onClickCreateUvv}
                    disabled={!workshoporder?.id || !workshoporder?.itemId}
                    title={
                      !workshoporder?.itemId
                        ? 'Keine Maschine am Werkstattauftrag – bitte zuerst Maschine zuordnen.'
                        : 'UVV-Bericht für diesen Auftrag anlegen.'
                    }
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '10px 14px',
                      backgroundColor: !workshoporder?.itemId ? '#b0b0b0' : '#28a745',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      cursor: !workshoporder?.itemId ? 'not-allowed' : 'pointer',
                      fontSize: '1rem',
                      fontWeight: 400,
                    }}
                  >
                    UVV-Bericht erzeugen
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => navigate(`/uvv/inspections/${uvvs[0].id}/edit`)}
                    title="Zum UVV-Bericht öffnen"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '10px 14px',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      cursor: 'pointer',
                      fontSize: '1rem',
                      fontWeight: 400,
                    }}
                  >
                    Zum UVV-Bericht {uvvs[0].certificateNumber ? `(${uvvs[0].certificateNumber})` : ''}
                  </button>
                )}
              </div>
              {/* ==================== /UVV Bericht ==================== */}



            </div>
          )}

        </div>

      
        {/* Mittlere Spalte - Mietzeitraum */}
        <div className="col">
          
          <div>
          <div className="form-group" style={{ marginBottom: '15px' }}>
  <label htmlFor="workshopOrderType">Auftragstyp:</label>
  <Select
    id="workshopOrderType"
    options={workshopOrderTypeOptions}
    value={
      workshopOrderTypeOptions.find(option => option.value === workshoporder.workshopOrderType) || null
    }
    onChange={(selectedOption) => {
      setworkshoporder(prev => ({
        ...prev,
        workshopOrderType: selectedOption ? selectedOption.value : ""
      }));
    }}
    placeholder="Bitte Auftragstyp wählen..."
    isClearable={false}
    styles={{
      control: (base) => ({
        ...base,
        marginTop: '10px',
        width: '100%',
      }),
      menu: (base) => ({
        ...base,
        zIndex: 11,
      }),
    }}
  />
</div>
          <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="allItemSelect">Artikel zuordnen:</label>
              <Select
                id="allItemSelect"
                options={allItems.map((item) => ({
                  value: item.id,
                  label: `${String(item.name)} (${String(item.itemType)})`
                }))} // Optionen formatieren
                value={
                  allItems
                  .map((item) => ({
                    value: item.id,
                    label: `${String(item.name)} (${String(item.itemType)})`
                  }))
                  .find((option) => option.value === workshoporder.itemId) || null
              }
              onChange={(selectedOption) => {
                const newValue = selectedOption ? selectedOption.value : null;
                setworkshoporder((prev) => ({ ...prev, itemId: newValue }));
                setSelectedAllItem(newValue);
              }}
                placeholder="Artikel suchen..."
                isClearable
                styles={{
                  control: (base) => ({
                    ...base,
                    marginTop: '10px',
                    width: '100%',
                  
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 11,
                  }),
                }}
              />
            </div>
            

            {/* Maschinensperre von Feld */}
            <label htmlFor="blockedPeriodFrom" className="full-width">
            Maschinensperre von:
              <input
                type="date"
                id="blockedPeriodFrom"
                name="blockedPeriodFrom"
                value={normalizeDateForInput(workshoporder.blockedPeriodFrom)}
                onChange={handleChange}
                className="input-box"
              />
            </label>

            {/* Maschinensperre bis Feld */}
            <label htmlFor="blockedPeriodTo" className="full-width">
            Maschinensperre bis:
              <input
                type="date"
                id="blockedPeriodTo"
                name="blockedPeriodTo"
                value={normalizeDateForInput(workshoporder.blockedPeriodTo)}
                onChange={handleChange}
                className="input-box"
              />
            </label>

           

            
            

            {/* Einsatzort (OperationLocation + Suggest) */}
          <div ref={opLocWrapRef} className="full-width" style={{ position: 'relative' }}>
            <label htmlFor="operationLocation">Einsatzort:</label>
            <input
              type="text"
              id="operationLocation"
              name="operationLocation"
              value={opLocInput}
              onChange={onOpLocChange}
              onFocus={onOpLocFocus}
              onBlur={onOpLocBlur}
              onKeyDown={onOpLocKeyDown}
              placeholder="Straße Hausnr., PLZ Ort"
              className="input-box"
              autoComplete="off"
              style={{ width: '100%' }}
            />

            {/* Suggest-Dropdown */}
            {opLocOpen && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  zIndex: 20,
                  background: '#fff',
                  border: '1px solid #ddd',
                  borderTop: 'none',
                  maxHeight: 260,
                  overflowY: 'auto',
                  boxShadow: '0 6px 18px rgba(0,0,0,0.08)'
                }}
                role="listbox"
                aria-labelledby="operationLocation"
              >
                {opLocLoading && (
                  <div style={{ padding: 10, color: '#666' }}>Lade Vorschläge …</div>
                )}
                {!opLocLoading && opLocSuggest.length === 0 && (
                  <div style={{ padding: 10, color: '#666' }}>Keine Treffer</div>
                )}
                {!opLocLoading &&
                  opLocSuggest.map((row, idx) => (
                    <div
                      key={`${row.label}-${idx}`}
                      onMouseDown={(e) => { e.preventDefault(); selectOpLoc(row.label); }}
                      onMouseEnter={() => setOpLocIndex(idx)}
                      role="option"
                      aria-selected={opLocIndex === idx}
                      style={{
                        padding: '10px 12px',
                        cursor: 'pointer',
                        background: opLocIndex === idx ? '#f0f6ff' : '#fff',
                        borderTop: '1px solid #f3f3f3',
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 12
                      }}
                      title={row.label}
                    >
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {row.label}
                      </span>
                      <span style={{ color: '#999', fontSize: 12 }}>
                        {typeof row.usageCount === 'number' ? `#${row.usageCount}` : ''}
                      </span>
                    </div>
                  ))}
              </div>
            )}
          </div>

            {/* Ansprechpartner vor Ort */}
            <label htmlFor="lwOperatorId" className="full-width">
              Ansprechpartner vor Ort:
              <select
                id="lwOperatorId"
                name="lwOperatorId"
                value={workshoporder.lwOperatorId}
                onChange={handleLWOperatorChange}
                className="select-box"
                style={{ marginLeft: '0px' }}
              >
                <option value="">Bitte Ansprechpartner vor Ort wählen</option>
                {lwOperatorContacts.map((contact) => (
                  <option key={contact.id} value={contact.id}>
                    {contact.contactFirstName} {contact.contactLastName}
                  </option>
                ))}
              </select>
            </label>

             

            {/* Auftragsnotiz */}
            <label htmlFor="notes" className="full-width" style={{ marginTop: '15px' }}>
              
              <textarea
                id="notes"
                name="notes"
                value={workshoporder.notes}
                onChange={handleChange}
                className="textarea-notes"
                rows="7"
                style={{ width: '98%', marginBottom: '20px', marginTop: '20px' }} // Breite kann hier angepasst werden
                placeholder="Auftragsnotiz"
              />
            </label>
          </div>
          
          <div className="col"></div>
          {/* Auftragspositionen */}
          <div className="table-breakout" style={{ marginTop: '70px' }}>
            <h3>Auftragspositionen</h3>

            {/* Log vor der Tabelle */}
            {console.log("Aktuelle Auftragspositionen:", workshoporderItems)}
           

            <table className="workshoporder-positions-table" >
              <thead>
                <tr>
                  <th style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>Position</th>
                  <th style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>Artikel</th>
                  <th style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>Beschreibung</th>
                  <th style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>Einheit</th>
                  <th style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>Menge</th>
                  <th style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>E-Preis</th>
                  <th style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>Gesamt</th>
                  
                  <th style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                {sortedItems.map((position, index) => {
                  const isRental = position.item?.itemType === 'rental';
                  const isInsuranceItem = position.item?.itemType === 'insurance';
                  const editingThisRow = editingRowId === position.id;

                  const unitName =
                    position.item?.machineType?.typePricings?.[0]?.unit?.name ||
                    position.item?.transportPricings?.[0]?.unit?.name ||
                    (isInsuranceItem ? 'Prozent' : 'n.a.');

                  let pricePerUnit = 0;
                  let total = 0;

                  // MBV-Berechnung
                  if (isInsuranceItem) {
                    const mainItem = workshoporderItems.find(
                      (item) => item.id === position.mainItemId
                    );

                    if (mainItem) {
                      const insurancePercentage = position.quantity;
                      const mbvPricePerUnit = (mainItem.pricePerUnit * insurancePercentage) / 100;
                      const mbvTotal = mbvPricePerUnit * mainItem.quantity;

                      pricePerUnit = mbvPricePerUnit;
                      total = mbvTotal;
                    }
                  } else if (position.pricePerUnit && position.quantity) {
                    pricePerUnit = position.pricePerUnit;
                    total = (position.quantity * position.pricePerUnit);
                  }

                  const isLinkedItem = !!position.mainItemId;

                  // Formatierung des Einzelpreises
                  const formattedPricePerUnit = (typeof pricePerUnit === 'number' && !isNaN(pricePerUnit))
                    ? pricePerUnit.toFixed(2).replace('.', ',') + ' €'
                    : '0,00 €';

                  // Formatierung des Gesamtpreises
                  const formattedTotal = (typeof total === 'number' && !isNaN(total))
                    ? total.toFixed(2).replace('.', ',') + ' €'
                    : '0,00 €';

                  return (
                    <tr key={position.id} style={isLinkedItem ? { paddingLeft: '20px' } : {}}>
                      {/* Positionsnummer */}
                      <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>{position.position ?? index + 1}</td>

                      {/* Artikelname */}
                      <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>
                      {editingThisRow && !isInsuranceItem ? (
                          <input
                            type="text"
                            value={position.item?.name || ''}
                            onChange={(e) =>
                              setworkshoporderItems((prev) =>
                                prev.map((item) =>
                                  item.id === position.id
                                    ? { ...item, item: { ...item.item, name: e.target.value } }
                                    : item
                                )
                              )
                            }
                          />
                        ) : (
                          position.item?.name
                        )}
                      </td>

                      {/* Beschreibung */}
                      <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>
                      {editingThisRow && !isInsuranceItem ? (
    <textarea
      value={position.description ?? position.item?.description ?? ''}
      onChange={(e) =>
        setworkshoporderItems((prev) =>
          prev.map((item) =>
            item.id === position.id
              ? { ...item, description: e.target.value }
              : item
          )
        )
      }
    />
  ) : (
    position.description || position.item?.description || 'Keine Beschreibung verfügbar'
  )}
</td>

                      {/* Einheit */}
                      <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>
                      {editingThisRow && !isInsuranceItem ? (
                          <>
                            {console.log("Einheiten für die Auftragsposition:", position.item)}

                            <select
                              value={position.unitId != null ? position.unitId.toString() : ''} // Zeige die aktuelle Einheit, nicht "Einheit wählen"
                              onChange={(e) => {
  const newUnitId = e.target.value ? parseInt(e.target.value, 10) : null;

  setworkshoporderItems((prev) =>
    prev.map((item) =>
      item.id === position.id
        ? { ...item, unitId: newUnitId }
        : item
    )
  );

  updateworkshoporderItemUnit(
    workshoporder.id,   // workshopOrderId
    position.id,        // workshoporderItemId
    newUnitId,
    position.quantity   // Menge
  );
}}

                            >
                              <option value="">Einheit wählen</option>
                              {position.item?.machineType?.typePricings
                                ?.map((pricing) => pricing.unit) // Alle verfügbaren Einheiten
                                ?.filter((unit, index, self) => unit && self.findIndex((u) => u.id === unit.id) === index) // Verhindere doppelte Einheiten
                                .map((unit) => (
                                  <option key={unit.id} value={unit.id.toString()}>
                                    {unit.name}
                                  </option>
                                ))}
                            </select>
                          </>
                        ) : (
                          position.unit?.name || '' // Zeige die Einheit im normalen Modus
                        )}
                      </td>

                      {/* Menge */}
                      <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>
                      {editingThisRow && !isInsuranceItem ? (
                          <input
                            type="number"
                            value={position.quantity || ''}
                            onChange={(e) =>
                              setworkshoporderItems((prev) =>
                                prev.map((item) =>
                                  item.id === position.id
                                    ? { ...item, quantity: parseFloat(e.target.value) || 0 }
                                    : item
                                )
                              )
                            }
                            min="0"
                          />
                        ) : (
                          isInsuranceItem ? `${position.quantity}%` : position.quantity
                        )}
                      </td>

                      {/* Einzelpreis */}
<td style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>
{editingThisRow && !isInsuranceItem ? (
    <input
      type="number"
      value={position.pricePerUnit || ''}
      onChange={(e) =>
        setworkshoporderItems((prev) =>
          prev.map((item) =>
            item.id === position.id
              ? { 
                  ...item, 
                  pricePerUnit: parseFloat(e.target.value) || 0,
                  manualPriceActive: true  // Flag setzen, wenn der Preis geändert wurde
                }
              : item
          )
        )
      }
      min="0"
      step="0.01"
    />
  ) : (
    // Formatierung des Einzelpreises mit Komma und Euro-Symbol
    (typeof position.pricePerUnit === 'number' && !isNaN(position.pricePerUnit))
      ? position.pricePerUnit.toFixed(2).replace('.', ',') + ' €'
      : '0,00 €'
  )}
</td>

                      {/* Gesamtpreis */}
                      <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>
                          {typeof total === 'number' && !isNaN(total)
                            ? total.toFixed(2).replace('.', ',') + ' €'
                            : '0,00 €'}
                        </td>
                        {isRental && (
                        <>
                           
                        </>
                      )}

                     {/* Aktionen */}
                     <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px' }}>
                     {editingThisRow ? (
                          <div style={{ display: 'flex' }}>
                            <button
                              type="button"
                              onClick={() => {
                                saveChanges();
                                setEditingRowId(null);
                              }}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#28a745',
                                color: '#fff',
                                bworkshoporder: 'none',
                                bworkshoporderRadius: '5px',
                              }}
                            >
                              Speichern
                            </button>
                            <button
                              type="button"
                              onClick={handleCancelEdit}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#6c757d',
                                color: '#fff',
                                bworkshoporder: 'none',
                                bworkshoporderRadius: '5px',
                                marginLeft: '10px',
                              }}
                            >
                              Abbrechen
                            </button>
                          </div>
                        ) : (
                          <div style={{ display: 'flex' }}>
                            {/* Verstecke/Deaktiviere den Bearbeiten-Button, falls insurance */}
            {!isInsuranceItem && (
                            <button
                type="button"
                onClick={() => setEditingRowId(position.id)}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: '#007bff',
                  color: '#fff',
                  bworkshoporder: 'none',
                  bworkshoporderRadius: '5px',
                  marginRight: '10px',
                }}
              >
                Bearbeiten
              </button>
              )}
                            <button
                              type="button"
                              onClick={() => removeworkshoporderItem(position.id)}
                              style={{
                                fontSize: '15px',
                                padding: '5px 10px',
                                background: '#dc3545',
                                color: '#fff',
                                bworkshoporder: 'none',
                                bworkshoporderRadius: '5px',
                              }}
                            >
                              Löschen
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>




            {/* Gesamtsummen-Tabelle */}
            <div style={{ marginTop: '20px', width: '100%', maxWidth: '800px' }}>
              <h3>Zusammenfassung</h3>
              <table style={{ bworkshoporderCollapse: 'collapse', width: '100%' }}>
                <tbody>
                  {/* Gesamt Netto */}
                  <tr>
                    <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px', fontWeight: 'normal' }}>Gesamt Netto</td>
                    <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung von totalNet */}
                      {(workshoporderItems.reduce((sum, item) => sum + (item.total || 0), 0).toFixed(2).replace('.', ',') || '0,00') + ' €'}
                    </td>
                  </tr>

                  {/* MwSt. */}
                  <tr>
                    <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px', fontWeight: 'normal' }}>zzgl. MwSt. ({workshoporder.vatRate ?? 19}%)</td>
                    <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung der MwSt. */}
                      {(
                        workshoporderItems.reduce((sum, item) => sum + (item.total || 0), 0) *
                        ((workshoporder.vatRate ?? 19) / 100)
                      ).toFixed(2).replace('.', ',') + ' €'}
                    </td>
                  </tr>

                  {/* Brutto */}
                  <tr>
                    <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px', fontWeight: 'bold' }}>Rechnungsbetrag</td>
                    <td style={{ bworkshoporder: '1px solid #ddd', padding: '8px', textAlign: 'right' }}>
                      {/* Berechnung des Bruttobetrags */}
                      {(
                        workshoporderItems.reduce((sum, item) => sum + (item.total || 0), 0) *
                        (1 + ((workshoporder.vatRate ?? 19) / 100))
                      ).toFixed(2).replace('.', ',') + ' €'}
                    </td>
                  </tr>
                </tbody>
              </table>
            
          </div>

         {/* Neue Auftragsposition hinzufügen */}
<div className="workshoporder-item-addition" style={{ marginTop: '20px' }}>
  <h3>Neue Auftragsposition hinzufügen</h3>
  
  <div className="form-group" style={{ marginBottom: '15px' }}>
    <label htmlFor="quantity">Menge:</label>
    <input
      type="number"
      id="quantity"
      value={selectedQuantity}
      onChange={(e) => setSelectedQuantity(e.target.value)}
      min="1"
      style={{ display: 'block', marginTop: '5px', marginBottom: '10px', padding: '8px', width: '100%', marginLeft: '0px' }}
    />
  </div>

  <div className="form-group" style={{ marginBottom: '15px' }}>
    <label htmlFor="itemId"></label>
    <Select
      id="itemId"
      options={items
        .filter(item => ['sale', 'service', 'sparePart', 'transport'].includes(item.itemType)) // Nur erlaubte Typen
        .map((item) => ({
          value: item.id,
          label: formatItemOptionLabel(item)

        }))
      }
      value={items
        .filter(item => ['sale', 'service', 'sparePart', 'transport'].includes(item.itemType))
        .map((item) => ({ value: item.id, label: formatItemOptionLabel(item) }))
        .find((option) => option.value === selectedItemId) || null
      }
      onChange={(selectedOption) => setSelectedItemId(selectedOption ? selectedOption.value : null)}
      onInputChange={(inputValue) => fetchFilteredItems(inputValue)}
      placeholder="Artikel suchen..."
      isClearable
      styles={{
        control: (base) => ({
          ...base,
          marginTop: '10px',
          width: '100%',
        }),
      }}
    />
  </div>
  
  <button type="button" onClick={addworkshoporderItem} style={{ padding: '10px 20px', cursor: 'pointer' }}>
    Auftragsposition hinzufügen
  </button>
</div>
</div>


        {/* Rechte Spalte - Auftragsnummer und Besteller */}
        <div className="col">

          
          
          {/* Auftragsnummer, Auftragsdatum und Auftragsgültigkeit anzeigen*/}
          {workshoporder.workshopOrderNumber && (
            <div>
               {workshoporder.invoices && workshoporder.invoices.length > 0 && (
      <button
        type="button"
        onClick={() => navigate(`/invoices/${workshoporder.invoices[0].id}/edit`)}
        style={{
          marginBottom: '10px',
          padding: '8px 12px',
          backgroundColor: '#28a745',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        Zur Rechnung
      </button>
    )}
              
              {/* Button nur anzeigen, wenn ein Mietauftrag (orderId) existiert */}
{Boolean(workshoporder.orderId) && (
  <button
    type="button"
    onClick={() => navigate(`/orders/${workshoporder.orderId}/edit`)}
    style={{
      marginBottom: '10px',
      padding: '8px 12px',
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    }}
  >
    Zum Auftrag
  </button>
)}


              <p><strong>WA-Nummer:</strong> {workshoporder.workshopOrderNumber}</p>
              <p><strong>WA-Datum:</strong> {workshoporder.date ? formatDate(workshoporder.date) : formatDate(new Date())}</p>
              
               {/* geplantes Erledigungsdatunm */}
               <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <label htmlFor="plannedExecuteDate"
    style={{ textAlign: 'center', marginBottom: '10px' }} // Hier ändert sich der Abstand
  >
    geplantes Erledigungsdatum:
  </label>
            <input
              type="date"
              id="plannedExecuteDate"
              name="plannedExecuteDate"
              value={normalizeDateForInput(workshoporder.plannedExecuteDate)}
              onChange={handleChange}
              className="select-box-bst"
              style={{ display: 'block', margin: '0 auto' }}
            />
          </div>
          <p><strong>Auftragsnummer:</strong> {workshoporder.orderNumber}</p>
              {/* Neues Eingabefeld für referenceNumber */}
    <label htmlFor="referenceNumber" className="full-width">
      <strong></strong>
      <input
        type="text"
        id="referenceNumber"
        name="referenceNumber"
        placeholder="Bestellnummer"
        value={workshoporder.referenceNumber || ""}
        style={{
          padding: '10px',
          bworkshoporderRadius: '4px',
          bworkshoporder: '1px solid #ccc',
          
          width: '250px',
        }}
        onChange={handleChange}
        className="input-box"
      />
    </label>

    {/* ------------------ Neues Feld: „Fertigstellungsdatum“ ------------------ */}
<div style={{ display: 'flex', flexDirection: 'column',  marginTop: '15px', marginBottom: '20px' }}>
  <label htmlFor="fulfillmentDate" className="full-width">
    <strong>Fertigstellungsdatum:</strong>
    <br />                          {/* ← hier der Umbruch */}
    <input
      type="date"
      id="fulfillmentDate"
      name="fulfillmentDate"
      value={normalizeDateForInput(workshoporder.fulfillmentDate)}
      onChange={handleFulfillmentDateChange} 
      className="input-box fulfillment-input"
      placeholder="TT.MM.JJJJ"
      style={{
        padding: '10px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        width: '250px',
        marginTop: '15px',
      }}
    />
  </label>
</div>
{/* ---------------------------------------------------------------------- */}


              
            </div>
          )}

          {customerContacts.length > 0 ? (
            <>
              <label htmlFor="contactId" className="full-width">
                
                <select
                  id="contactId"
                  name="contactId"
                  value={workshoporder.contactId}
                  onChange={handleContactChange}
                  className="select-box-bst"
                >
                  <option value="">Besteller wählen</option>
                  {customerContacts.map((contact) => (
                    <option key={contact.id} value={contact.id}>
                      {contact.contactFirstName} {contact.contactLastName}
                    </option>
                  ))}
                </select>
              </label>

              {/* Anzeige der Bestellerinformationen */}
              {selectedContact && (
                <div className="contact-details">
                  <p><strong>Name:</strong> {selectedContact.contactFirstName} {selectedContact.contactLastName}</p>
                  <p><strong>Mobil:</strong> {selectedContact.contactMobile}</p>
                  <p><strong>Email:</strong> {selectedContact.contactEmail}</p>
                </div>
              )}

              

             
            </>
          ) : (
            <p>Keine Besteller verfügbar</p>
          )}
        </div>
        

      </div>
      

      <div className="actions">
   {/*     <button type="button" onClick={handleBackButtonClick} style={{ marginRight: '10px', padding: '10px 20px', cursor: 'pointer' }}>
          Zurück
        </button>   */}
        <button type="button" onClick={handleSave} style={{ padding: '10px 20px', cursor: 'pointer' }}>
          {mode === "edit" ? "Speichern" : "Erstellen"}
        </button>
      </div>
{/* ===== UVV-Typ Auswahl Modal ===== */}
      {uvvModalOpen && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
          }}
          onClick={() => setUvvModalOpen(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 'min(92vw, 420px)', background: '#fff', borderRadius: 10,
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)', padding: 20
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: 8 }}>Welche Prüfung?</h3>

            <div style={{ display: 'flex', gap: 12, margin: '12px 0' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, padding: 10, border: '1px solid #ddd', borderRadius: 8, flex: 1, cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="uvvType"
                  value="main"
                  checked={uvvTypeChoice === 'main'}
                  onChange={() => setUvvTypeChoice('main')}
                />
                Hauptprüfung
              </label>

              <label style={{ display: 'flex', alignItems: 'center', gap: 8, padding: 10, border: '1px solid #ddd', borderRadius: 8, flex: 1, cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="uvvType"
                  value="retest"
                  checked={uvvTypeChoice === 'retest'}
                  onChange={() => setUvvTypeChoice('retest')}
                />
                Nachprüfung
              </label>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
              <button type="button" onClick={() => setUvvModalOpen(false)} style={{ padding: '8px 12px' }}>
                Abbrechen
              </button>
              <button type="button" onClick={confirmCreateUvv} style={{ padding: '8px 12px', background: '#28a745', color: '#fff', border: 'none', borderRadius: 6 }}>
                Anlegen
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ===== /UVV-Typ Auswahl Modal ===== */}

    </div>
  );
};

export default WorkshopOrderForm;
